export default {
    'searchList': {
        'searchTxt': [{
            'name': '合同编号',
            'value': 'ettaContractNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }],
        'unfoldState': false,
        'advancedBtn': false
    },
    'table':
    {
        'clickState': false,
        'height': 400,
        'columns': [
            {
                'label': '运输单号',
                'prop': 'ettaNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户订单号',
                'prop': 'ettaSoNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '集拼号',
                'prop': 'ettaAssighNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '合同编号',
                'prop': 'ettaContractNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备号',
                'prop': 'deviceName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '紧急程度',
                'prop': 'ettaLevelType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户',
                'prop': 'ettaCustomEbcuNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '线路',
                'prop': 'ettaEblnLineName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '体积',
                'prop': 'ettaVolume',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '重量',
                'prop': 'ettaWeight',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '数量',
                'prop': 'ettaQuantity',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输方式',
                'prop': 'ettaTranTypeNew',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '服务平台',
                'prop': 'siteName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求发货时间',
                'prop': 'ettaReqDeliveryDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '要求送达时间',
                'prop': 'ettaReqArrivalDate',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '是否预约',
                'prop': 'ettaReservationType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '客户预约单号',
                'prop': 'ettaReservationNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '预约送货时间',
                'prop': 'ettaReservationTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '运输单状态',
                'prop': 'ettaStatusType',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单类型',
                'prop': 'ettaOrderTypeName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货地',
                'prop': 'ettaEtorFromEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '装货仓库',
                'prop': 'ettaOutWhName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '订单送达地址',
                'prop': 'ettaEtorToEbrgAddress',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货单位',
                'prop': 'ettaConsigneeEbspNameCn',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系人',
                'prop': 'ettaToContactName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系手机',
                'prop': 'ettaToContactMobile',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '收货联系电话',
                'prop': 'ettaToContactTel',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '提货区域',
                'prop': 'esstFromCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '送达区域',
                'prop': 'esstToCityName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '开票单位',
                'prop': 'ettaSourceCustomerCode',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '营销中心名称',
                'prop': 'ettaProductCenterName',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '备注',
                'prop': 'ettaRemark',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '物流订单号',
                'prop': 'ettaOrderNo',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备绑定时间',
                'prop': 'deviceBundTime',
                'sort': true,
                'width': '148px'
            },
            {
                'label': '设备回收时间',
                'prop': 'deviceBackTime',
                'sort': true,
                'width': '148px'
            }
        ]
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageSizes': [10, 20, 30, 50, 100] // eslint-disable-line
    }
};
